import { Typography } from "@novaescola/eva-react-v2/lib/Typography";
import { useLocation } from "@reach/router";
import React, { useState } from "react";
import { FacebookShareButton, WhatsappShareButton } from "react-share";
import Image from '../general/Image';
import { MENECardToConfirmUserRegion } from "./MENECardToConfirmUserRegion";
import { Button } from "@novaescola/eva-react-v2";
import { sanitizeHtml } from "../../utils/sanitize";
import ButtonsActionSection from "./ButtonsActionSection";
import Users from '../../images/users.png'
import MaoLuz from '../../images/maoLuz.png'

export function HeaderSection({ section, pageTitle, slug, user }) {
	const { href: url } = useLocation();
	const { 
		btnPrimaryBackground, 
		btnPrimaryText, 
		btnSecondaryBackground, 
		btnSecondaryColorText, 
		haveSecondButton 
	} = section.body || {};

	const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;

	
	const isLpFerramentaSondagem = slug.includes("sondagem-alfabetizacao")
	const isComunidadeNE= slug.includes("comunidade-nova-escola")
	const isPlanejadorSaoLuis = slug.includes('planejador-de-sao-luis')
	const colorButtonShare = section.body?.textColor === '#FFFFFF' || section.body?.textColor === '#ffffff' ? "eva-btn-outline-branco" : "eva-btn-outline";
	const isMidiaKitLP = slug.includes("midia-kit")
		const [showModal, setShowModal] = useState(false)
	const [linkRedirect, setLinkRedirect] = useState("")

	const renderShareButtons = () => {
		if (isLpFerramentaSondagem) {
		  return (
			<div className="share-link d-flex">
			  <Button color="white" size="medium" fill="filled">
				<a
				  href="https://novaescola.org.br/sala-do-professor/"
				  target="_self"
				  rel="noreferrer"
				  type="button"
				  className="eva-margin-center"
				  data-track={`SITE: Click - LP sala do professor - seção chamada - Botão do bloco 01 - ACESSE AGORA`}
				>
				  ACESSAR A FERRAMENTA
				</a>
			  </Button>
			</div>
		  );
		}
	
		if (isMidiaKitLP) {
		  return null;
		}
		
		if (!isPlanejadorSaoLuis) { 
			return (
				<div className="share-link d-flex">
					<WhatsappShareButton
						url={url}
						windowWidth={900}
						resetButtonStyle={false}
						className={`eva-btn-icon ${colorButtonShare} eva-btn-medium eva-margin-right-2`}
						aria-label="Compartilhar WhatsApp"
						data-track={`SITE: Click - ${pageTitle} - compartilhar whatsapp`}
					>
						<i className="fab fa-whatsapp"></i>
					</WhatsappShareButton>
					<FacebookShareButton
						url={url}
						resetButtonStyle={false}
						className={`eva-btn-icon ${colorButtonShare} eva-btn-medium`}
						aria-label="Compartilhar Facebook"
						data-track={`SITE: Click - ${pageTitle} - compartilhar facebook`}
					>
						<i className="fab fa-facebook-f"></i>
					</FacebookShareButton>
				</div>
			);
		}
	};

	function isSectionButtonEnabled(section, isSecondButton) {
		if (
			!section.body?.buttonEnabledAt ||
			(isSecondButton && !section.body?.secondButtonEnabledAt)
		) {
			return true
		}

		return isSecondButton
			? new Date(section.body?.secondButtonEnabledAt).getTime() <
			new Date().getTime()
			: new Date(section.body?.buttonEnabledAt).getTime() < new Date().getTime()
	}
	
	return (
		<section>
		<div
			className="container-fluid eva-bg-inst-500 eva-color-branco"
			style={{ backgroundColor: section.body?.backgroundColor }}
		>
			<div className="container banner">
				<div
					className={`row container-blocks ${section.body?.imageAlign === "left"
						? "image-aling-left"
						: "image-aling-rigth"
						}`}
				>
					<div className="col-lg-6 col-md-6 col-sm-12 image-block">
						<Image
							remoteImage={section.body?.remoteImage}
							fallbackImageUrl={section.body?.imageUrl}
							alt=""
						/>
					</div>
					<div
						className="col-lg-6 col-md-6 col-sm-12 text-block"
					>
						<Typography variant="title" size={4} asChild
							className="eva-margin-bottom-2"
							style={{ color: section.body?.textColor }}
						>
							<h1>{section.body?.title}</h1>
						</Typography>
						<Typography variant="body" size={1} asChild
							className="eva-margin-bottom-4"
							style={{ color: section.body?.textColor }}
						>
							<div
								dangerouslySetInnerHTML={{
									__html: section.body?.subtitle ? 
										sanitizeHtml(section.body?.subtitle) 
										: '',
								}}
							/>
						</Typography>

						<MENECardToConfirmUserRegion sectionTitle={section.body?.title} />

						{
							section.body?.hideLinkButton && section.body?.buttonEnabledText ? (
								isSectionButtonEnabled(section, true) ? (
									<ButtonsActionSection
										buttonEnabledText={section.body?.buttonEnabledText}
										buttonLink={section.body?.buttonLink}
										addRegistrationBlockingButton={section.body?.addRegistrationBlockingButton}
										pageTitle={pageTitle}
										section={section}
										user={user}
									/>
								) : (
									<div className="d-flex align-buttom">
										<Button
											disabled
											variant="primary"
											size="medium"
											aria-disabled="true"
											style={{ 
												...(btnPrimaryText && { color: btnPrimaryText }),
												...(btnPrimaryBackground && { backgroundColor: btnPrimaryBackground }),
											}}
										>
											{section.body?.buttonDisabledText}
										</Button>

										{haveSecondButton && 
											<Button
												disabled
												variant="primary"
												size="medium"
												aria-disabled="true"
												style={{ 
													...(btnSecondaryColorText && { color: btnSecondaryColorText }),
													...(btnSecondaryBackground && { backgroundColor: btnSecondaryBackground }),
												}}
											>
												{section.body?.secondButtonDisabledText}
											</Button>
										}
									</div>
								)
							) : (
								renderShareButtons()
							)
						}
					</div>
				</div>
			</div>
		</div>
			{isComunidadeNE && (
				<section style={{
					backgroundColor: '#E32459',
		
					}}>
				<div
						className="container blocks"
						style={{
					backgroundColor: '#E32459',
					display: 'flex',
					flexDirection: isMobile ? 'column' : 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
					gap: isMobile ? '20px' : '0',
					padding: isMobile ? '20px 0' : '0',
						height: isMobile ? 'auto' : '92px',
					padding: isMobile ? '20px' :  '65px 40px'
					}}
				>
					<div style={{display:'flex', gap:'10px', justifyContent:'center', alignItems:'center'}}>
						<div
							style={{
								borderRadius: '50%',
								background: '#fff',
								width: isMobile ? '60px' : '76px',
								height: isMobile ? '60px' : '76px',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}
							>
							<img src={Users} alt={'Users'} width={60} height={60}/>
						</div>
						<p
							style={{
								fontWeight: 800,
								color: 'white',
								fontSize: isMobile ? '16px' : '20px',
								textAlign: isMobile ? 'center' : 'left',
								lineHeight: '1.2',
							}}
							>
							+700 membros<br></br> em todo o Brasil
						</p>
					</div>
					<div style={{ display: 'flex', gap: '10px', justifyContent: 'center', alignItems: 'center' }}>
						<div
							style={{
								borderRadius: '50%',
								background: '#fff',
								width: isMobile ? '60px' : '76px',
								height: isMobile ? '60px' : '76px',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}
							>
							<svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" version="1.0" viewBox="1.0 1.0 30.0 30.0" zoomAndPan="magnify" style={{ fill: 'rgb(227, 36, 89)' }} original_string_length="1287" width="51.06782618577259px" height="51.06782618577259px">
								<path d="M25.5,12c3.03223,0,5.5-2.46729,5.5-5.5S28.53223,1,25.5,1S20,3.46729,20,6.5c0,0.52856,0.07916,1.03821,0.21899,1.52234 l-9.33905,4.66974C9.85907,11.32495,8.26135,10.5,6.5,10.5C3.46729,10.5,1,12.96729,1,16s2.46729,5.5,5.5,5.5 c1.76385,0,3.36365-0.82709,4.38123-2.19147l9.33777,4.66913C20.07916,24.46179,20,24.97144,20,25.5c0,3.03271,2.46777,5.5,5.5,5.5 s5.5-2.46729,5.5-5.5S28.53223,20,25.5,20c-1.78937,0-3.37732,0.86304-4.38239,2.19061L11.776,17.51959 C11.91895,17.0293,12,16.52271,12,16c0-0.52374-0.08112-1.03107-0.22351-1.51984l9.34113-4.67078 C22.12268,11.13696,23.71063,12,25.5,12z M25.5,22c1.92969,0,3.5,1.57031,3.5,3.5S27.42969,29,25.5,29S22,27.42969,22,25.5 S23.57031,22,25.5,22z M6.5,19.5C4.57031,19.5,3,17.92969,3,16s1.57031-3.5,3.5-3.5c1.33887,0,2.53516,0.74072,3.12842,1.94336 C9.875,14.92822,10,15.45166,10,16s-0.125,1.07178-0.37695,1.56738C9.03516,18.75928,7.83887,19.5,6.5,19.5z M25.5,3 C27.42969,3,29,4.57031,29,6.5S27.42969,10,25.5,10S22,8.42969,22,6.5S23.57031,3,25.5,3z" style={{fill:'inherit'}} />
							</svg>
									
						</div>
												<p
							style={{
								fontWeight: 800,
								color: 'white',
								fontSize: isMobile ? '16px' : '20px',
								textAlign: isMobile ? 'center' : 'left',
								lineHeight: '1.2',
							}}
							>
							+80 núcleos de<br></br> compartilhamento <br></br> de práticas
						</p>
					</div>
					
					<div style={{display:'flex', gap:'10px', justifyContent:'center', alignItems:'center'}}>
						<div
							style={{
								borderRadius: '50%',
								background: '#fff',
								width: isMobile ? '60px' : '76px',
								height: isMobile ? '60px' : '76px',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}
							>
							  <img src={MaoLuz} alt={'MaoLuz'} width={45} height={45}/>
						</div>
												<p
							style={{
								fontWeight: 800,
								color: 'white',
								fontSize: isMobile ? '16px' : '20px',
								textAlign: isMobile ? 'center' : 'left',
								lineHeight: '1.2',
							}}
							>
							De professor para<br></br> professor com foco <br></br> na solução
						</p>
					</div>
					
				</div>
				</section>
			)}
		</section>
	)
}
